<template>

  <div class="container">

    <div class="form-wizard-tab-content">
      <div class="form-wizard-tab-content-text">
        <p></p>
      </div>
      <div class="form-group with-icon-right">
        <div class="input-group">
          <input
            name="fullName"
            data-vv-as="fullName"
            v-model="fullName"
            v-validate="'required'"
            required title=""/>
          <i
            class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa fa-check valid-icon icon-right input-icon"></i>
          <label class="control-label">{{'personalDetails.name' | translate}}</label><i class="bar"></i>
          <small v-show="errors.has('companyVatNumber')" class="help text-danger">
            {{ errors.first('companyVatNumber') }}
          </small>
        </div>
      </div>
    </div>

    <div class="form-wizard-tab-content">
      <div class="form-wizard-tab-content-text">
        <p></p>
      </div>
      <div class="form-group with-icon-right">
        <div class="input-group">
          <input
            name="phone"
            data-vv-as="phone"
            v-model="phone"
            v-validate="'required'"
            required title=""/>
          <i
            class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa fa-check valid-icon icon-right input-icon"></i>
          <label class="control-label">{{'personalDetails.phone' | translate}}</label><i class="bar"></i>
          <small v-show="errors.has('companyVatNumber')" class="help text-danger">
            {{ errors.first('companyVatNumber') }}
          </small>
        </div>
      </div>
    </div>

    <div class="form-wizard-tab-content">
      <div class="form-wizard-tab-content-text">
        <p></p>
      </div>
      <div class="form-group with-icon-right">
        <div class="input-group">
          <input
            name="emailAddress"
            data-vv-as="emailAddress"
            v-model="emailAddress"
            v-validate="'required'"
            required title=""/>
          <i
            class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa fa-check valid-icon icon-right input-icon"></i>
          <label class="control-label">{{'personalDetails.email' | translate}}</label><i class="bar"></i>
          <small v-show="errors.has('companyVatNumber')" class="help text-danger">
            {{ errors.first('companyVatNumber') }}
          </small>
        </div>
      </div>
    </div>

    <div class="form-wizard-tab-content">
      <div class="form-wizard-tab-content-text">
        <p></p>
      </div>
      <div class="form-group with-icon-right">
        <div class="input-group">
          <input
            name="webPage"
            data-vv-as="webPage"
            v-model="webPage"
            v-validate="'required'"
            required title=""/>
          <i
            class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa fa-check valid-icon icon-right input-icon"></i>
          <label class="control-label">{{'personalDetails.webPage' | translate}}</label><i class="bar"></i>
          <small v-show="errors.has('companyVatNumber')" class="help text-danger">
            {{ errors.first('companyVatNumber') }}
          </small>
        </div>
      </div>
    </div>

    <div class="form-wizard-tab-content">
      <div class="form-wizard-tab-content-text">
        <p></p>
      </div>
      <div class="form-group with-icon-right">
        <div class="input-group">
          <input
            name="address"
            data-vv-as="address"
            v-model="address"
            v-validate="'required'"
            required title=""/>
          <i
            class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa fa-check valid-icon icon-right input-icon"></i>
          <label class="control-label">{{'personalDetails.address' | translate}}</label><i class="bar"></i>
          <small v-show="errors.has('companyVatNumber')" class="help text-danger">
            {{ errors.first('companyVatNumber') }}
          </small>
        </div>
      </div>
    </div>

    <div class="flex-center bottomMargin20">
      <button class="btn btn-primary btn-with-icon" @click="saveChanges()">
        <div class="btn-with-icon-content">
          <i class="ion-md-open ion"></i>
          {{'personalDetails.save' | translate}}
        </div>
      </button>
    </div>

  </div>

</template>

<script>
import { profileApi } from '../../services/api/profileApi'

export default {
  name: 'personal-data',

  data: function () {
    return {
      fullName: '',
      phone: '',
      emailAddress: '',
      webPage: '',
      address: ''
    }
  },

  methods: {
    saveChanges () {
      profileApi.update({
        id: this.$store.state.app.user.userId,
        fullName: this.fullName,
        emailAddress: this.emailAddress
      })
    }
  }
}
</script>

<style scoped>
  .form-wizard-tab-content {
    max-width: 15em;
  }
</style>
